export default function ButtonDownController(view) {
  return ({
    index
  }) => {
    console.log("ButtonDownCtrl", index);
    view.resolve("start");

    // switch (index) {
    //     case 0:
    //     case 1:
    //     case 2:
    //     case 3:
    //     default: // any other key
    // }
  };
}